import { createSelector } from "@reduxjs/toolkit";
import { getConvertedMods } from "@src/store/slices/experienceBuilder/common/selectors/getConvertedMods";
import { getModStats } from "@intelligems/ig-utils/get-mod-stats";

/**
 * Mods enriched with per-mod status (new / changed / unchanged) so the AI
 * can reason about which entries are its own in-session work vs. the
 * merchant's pre-existing saved state.
 */
export const getAiModStats = createSelector(
  getConvertedMods,
  ({ onsiteEdits, onsiteInjections }) =>
    getModStats(onsiteEdits, onsiteInjections, "ai")
);
